import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

interface LabeledLinkProps {
  label: string;
  url: string;
}

const normalizeUrl = (url: string) => {
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
};

export const LabeledLink: React.FC<LabeledLinkProps> = ({ label, url }) => {
  const href = normalizeUrl(url);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:underline hover:text-indigo-800 transition-colors">
      {label}
      <ArrowTopRightOnSquareIcon className="w-4 h-4" />
    </a>
  );
};
